import React, { useContext } from 'react'
import { Container, SubTitle, Button, Title, UploadBox } from '@provi/provi-components'
import { Form } from '../../../components/form'
import { TemplateContext } from '../../../components/template/context'
import { TemplateForm } from '../../../components/template-form'
import { useCNH } from './hooks'
import img_document from '../../../assets/svg/personal-document.svg'

const OPTIONS_DROPZONE = 'image/jpeg, image/png, application/pdf'

export const PersonalDocumentCnh = () => {
  const { goToNextScreen, setIsLoading, creditPath } = useContext(TemplateContext)
  const [
    isButtonDisabled,
    numberOfFiles,
    preview,
    setPreview,
    setFilesNotUpload,
    filesNotUpload,
    setNumberOfFiles,
    numberOfFilesInitial,
    onSubmit
  ] = useCNH(goToNextScreen, creditPath, setIsLoading)

  return (
    <TemplateForm>
      <Container>
        <Form onSubmit={e => onSubmit(e)}>
          <Title text="Envie sua CNH aberta" />
          <SubTitle text="As informações devem estar legíveis" />
          <UploadBox
            preview={preview}
            setPreview={setPreview}
            setFilesNotUpload={setFilesNotUpload}
            filesNotUpload={filesNotUpload}
            setNumberOfFiles={setNumberOfFiles}
            numberOfFiles={numberOfFiles}
            numberOfFilesInitial={numberOfFilesInitial}
            image={img_document}
            options={OPTIONS_DROPZONE}
          />
          <Button marginHorizontal={0} type="submit" disabled={isButtonDisabled} text="Avançar" persistFloatingMode={false} />
        </Form>
      </Container>
    </TemplateForm>
  )
}
